/*
    RSSMOD-906: https://jira.westat.com/browse/RSSMOD-906
    RSSMOD-907: https://jira.westat.com/browse/RSSMOD-907
*/
import http from 'helpers/APIHelper';
import { map } from 'rxjs/operators';
import { getSessionByKey } from 'helpers';

export const triggerProtocolProcessStatus = (token, loggerInfo, id, postBody) => (
  dispatch,
  getState
) => http.putWithToken(
  `protocol-data-service/${
    getSessionByKey('prt_url_ver')
  }/protocols/id/${id}/status/overdue`,
  token,
  loggerInfo,
  JSON.stringify(postBody)
).pipe(
  map(resp => {
    return resp;
  })
);
